import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap} from './PlaySounds';

class AboutScreen extends Component {

  constructor(props){
      super(props);
      this.state = {
          error : null,
          isLoaded : false,
          configs : []          
      };
  }

  componentDidMount() {
        fetch('/game-skins/build-rev23-PfhLPVSBF/data_'+this.props.language+'/game_custom_config.json')
        .then( response => response.json())
        .then(
            // handle the result
            (result) => {
                this.setState({
                    isLoaded : true,
                    configs : result
                });
            },

            // Handle error 
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                })
            },
        )
      }

   goToMainMenu = () => {
        playButtonTap();
        this.props.history.push('/mainmenu');
    };
    

    render() {
      var content = "";
      var title = ""
      var direction = "";
      var GameAbout = this.state.configs.map(config => (config.GameAbout))
      if(this.props.language === "en"){
          content =GameAbout;
           title = "About";
           direction = "ltr";
      }else if(this.props.language === "ur"){
          content = GameAbout;
          title = "گیم کے بارے میں"
          direction = "rtl";
      }
            return(
                <div className = "screen_background popup_top_padding">
                  <div className = "popup">
                    <div dir={direction} className = "scroll_pupop_title">
                        {title}
                    </div>
                    <div  className= "scroll_div scroll_div_with_title">
                      <div dir={direction}   dangerouslySetInnerHTML={{ __html:content}} >
                      </div>  
                      </div>
                  </div>
                  <img src={"/game-skins/build-rev23-PfhLPVSBF/images_"+this.props.language+"/btn_back.png"} alt="" className="button" onClick = {this.goToMainMenu}/>
                </div>
            )
    }
}
AboutScreen.propTypes = {
  language:PropTypes.string.isRequired,
  error : PropTypes.string,
  isLoaded : PropTypes.bool,
  configs: PropTypes.array
}

const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  error : null,
  isLoaded : false,
  configs: []
});

export default connect(mapStateToProps)(AboutScreen);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/AboutScreen.js